import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { HttpError } from "../helpers/Error"
import DataFlow from "./DataFlow"

type ExecuteOnBoardingStepResponse = {
 step: string
}

class OnBoardingService {

    async ExecuteOnBoardingStep(currentStep: string, payload: object): Promise<ExecuteOnBoardingStepResponse | HttpError> {
        return AppContext.getApiClient().post(`/accounts/setup/${currentStep}`, payload)
    }

    async GetDataFlow(accountID: string): Promise<DataFlow | HttpError> {
        const res = await AppContext.getApiClient().get(`/on-boarding/${accountID}/data-flow`)
        if (!res.error) {
            return new DataFlow(res)
        }
        return res as HttpError
    }

    async UpdateDataFlow(accountID: string, payload: object): Promise<DataFlow | HttpError> {
        const res = await AppContext.getApiClient().patch(`/on-boarding/${accountID}/data-flow`, payload)
        if (!res.error) {
            return new DataFlow(res)
        }
        return res as HttpError
    }

}

const instance = new OnBoardingService()
export default instance


// WEBPACK FOOTER //
// ./src/state/onboarding/OnBoardingService.ts